<template>
  <div class="content">
    <Header :title="'我的推广'" />
    <div class="info-base-wrap">
      <div class="info-base">
        <h3>我的总佣金</h3>
        <h3>{{ totalMoney }}</h3>
        <div class="cards">
          <div class="my-card">
            <h4>冻结金额</h4>
            <h5>{{ frozenMoney }}元</h5>
            <span class="line" />
          </div>
          <div class="my-card">
            <h4>佣金</h4>
            <h5>{{ extractMoney }}元</h5>
          </div>
        </div>
        <div v-show="memberLevelId===2" class="code-wrap">
          <router-link to="/Personal/Spread/InviteCode">邀请码</router-link>
        </div>
        <div class="money-wrap">
          <router-link to="/Personal/Spread/MoneyExtract">
            <div class="extract">
              <img src="@/assets/images/icon-money.png">
              提现
            </div>
          </router-link>
        </div>
      </div>
      <div class="info-users">
        <div class="my-users-title">
          <router-link to="/Personal/Spread/RuleMoney">
            <span>我的推广用户</span>
            <i class="iconfont">&#xe631;</i>
          </router-link>
        </div>
        <div class="my-users">
          <ul>
            <li v-for="item in users" :key="item.id">
              <div class="img-wrap">
                <img v-show="item.headPicture" :src="item.headPicture" alt>
                <img v-show="!item.headPicture" src="@/assets/images/test-recently.png" alt>
              </div>
              <div class="user">
                <p class="name">{{ item.nickName||'匿名' }}</p>
                <p class="phone">{{ item.phone||'暂无' }}</p>
              </div>
              <div class="date">{{ item.createdDate }}</div>
            </li>
            <div v-show="users.length===0" class="no-data">您还没有推广用户哦</div>
          </ul>
        </div>
      </div>
      <nut-backtop :bottom="70" :right="10" :z-index="10" :duration="1000">
        <i class="iconfont back-top">&#xe66a;</i>
      </nut-backtop>
    </div>
    <Footer :active="4" />
  </div>
</template>
<script>
import { Toast } from '@nutui/nutui'
import { baseInfo } from '@/api/Personal/index'
import { pageData, userList } from '@/api/Personal/Spread/index'
import Header from '@/components/Header/Index'
import Footer from '@/components/Footer/Index'
export default {
  name: 'Spread',
  components: {
    Header,
    Footer
  },
  data() {
    return {
      memberLevelId: 2, // 1:加盟商 2：业务员 3：消费者
      data: {
        pageIndex: 0,
        pageSise: 100
      },
      totalMoney: 0, // 余额
      frozenMoney: 0, // 冻结金额
      extractMoney: 0, // 佣金
      users: []
    }
  },
  mounted() {
    this.initPage()
    this.getList()
  },
  methods: {
    initPage() {
      pageData().then(res => {
        if (res && res.success) {
          if (res.data) {
            this.frozenMoney = this.isLegal(res.data.frozenMoney)
            this.extractMoney = this.isLegal(res.data.extractMoney)
            this.totalMoney = this.frozenMoney + this.extractMoney
          }
        } else {
          Toast.fail(res.msg)
        }
      })
      baseInfo().then(res => {
        if (res && res.success) {
          if (res.data) {
            this.memberLevelId = res.data.memberLevelId
          }
        } else {
          Toast.fail(res.msg)
        }
      })
    },
    getList() {
      const _this = this
      userList(this.data).then(res => {
        if (res && res.success) {
          if (res.data) {
            if (res.data.rows) {
              const rows = res.data.rows
              rows.forEach(item => {
                item.createdDate = item.createdDate.slice(0, 10)
                if (item.headPicture !== 'null') {
                  item.headPicture = _this.$resUrl(item.headPicture)
                } else {
                  item.headPicture = null
                }
              })
              _this.users = rows
            }
          }
        } else {
          Toast.fail(res.msg)
        }
      })
    },
    // 安全检测
    isLegal(data) {
      if (data < 0) {
        return 0
      } else {
        return data
      }
    }
  }
}
</script>
<style lang="scss" scoped>
@import '@/styles/index.scss';
.content {
  width: 100vw;
  min-height: 0;
  height: auto;
  padding: 20px 13px 80px 13px;
  overflow: hidden;
  box-sizing: border-box;
  .info-base-wrap {
    width: 100%;
    min-height: 164px;
    height: auto;
    overflow: hidden;
    box-sizing: border-box;
    position: relative;
    .info-base {
      background: url('~@/assets/images/spread-bg.png') no-repeat #ffffff;
      background-size: 100% 100%;
      width: calc(100% - 10px);
      height: 154px;
      box-sizing: border-box;
      padding: 15px 25px 0 25px;
      margin: 5px auto;
      @extend %boxShadow;
      position: relative;
      h3 {
        text-align: center;
        font-size: 25px;
        color: #c4890c;
        margin: 0;
        padding: 0;
        @extend %ellipsis;
      }
      .cards {
        width: 100%;
        height: 65px;
        position: relative;
        overflow: hidden;
        border-top: 1px solid #e8e8e8;
        box-sizing: border-box;
        margin-top: 6px;
        .my-card {
          width: 50%;
          height: 46px;
          float: left;
          box-sizing: border-box;
          margin: 16px 0 0 0;
          position: relative;
          h4 {
            text-align: center;
            color: #4d4d4d;
            margin: 0;
            padding: 0;
            font-size: 14px;
            position: relative;
            @extend %ellipsis;
          }
          h5 {
            text-align: center;
            color: #999999;
            margin: 0;
            padding: 0;
            font-size: 12px;
            @extend %ellipsis;
          }
          .line {
            display: block;
            position: absolute;
            width: 1px;
            height: 20px;
            background: #e8e8e8;
            right: 0;
            top: 5px;
          }
        }
      }
      .code-wrap {
        width: 52px;
        height: 20px;
        border-radius: 5px;
        border: 1px solid #fcb20b;
        position: absolute;
        right: 50px;
        top: 22px;
        text-align: center;
        font-size: 12px;
        line-height: 20px;
        a {
          color: #fcb20b;
          display: block;
          width: 100%;
          height: 100%;
          font-weight: 600;
        }
      }
      .money-wrap {
        width: 60px;
        height: 26px;
        border-top-left-radius: 26px;
        border-bottom-left-radius: 26px;
        overflow: hidden;
        position: absolute;
        right: 0;
        top: 50px;
        a {
          display: block;
          width: 100%;
          height: 100%;
          .extract {
            width: 100%;
            height: 100%;
            background: #d08d04;
            color: #ffffff;
            font-size: 12px;
            line-height: 26px;
            text-align: left;
            position: relative;
            box-sizing: border-box;
            padding: 0 0 0 25px;
            img {
              width: 12px;
              height: 12px;
              position: absolute;
              left: 10px;
              top: 6px;
            }
          }
        }
      }
    }
    .info-users {
      width: calc(100% - 10px);
      min-height: 57px;
      height: auto;
      overflow: hidden;
      box-sizing: border-box;
      margin: 0 auto;
      .my-users-title {
        width: 100%;
        height: 57px;
        position: relative;
        a {
          display: block;
          width: 100%;
          height: 100%;
          outline: none;
          display: flex;
          justify-content: space-between;
          align-items: center;
        }
        span {
          border-bottom: 3px solid #fcb20b;
          color: #4d4d4d;
          font-size: 14px;
          font-weight: 600;
        }
        i {
          font-size: 22px;
          color: #fcb20b;
        }
      }
      .my-users {
        width: 100%;
        min-height: 0;
        height: auto;
        overflow: hidden;
        background: #ffffff;
        ul {
          box-sizing: border-box;
          padding: 0 8px;
          li {
            width: 100%;
            height: 61px;
            position: relative;
            float: left;
            box-sizing: border-box;
            overflow: hidden;
            border-bottom: 1px solid #e5e5e5;
            .img-wrap {
              width: 40px;
              height: 40px;
              position: absolute;
              left: 8px;
              top: 10px;
              border-radius: 20px;
              overflow: hidden;
              img {
                width: 100%;
                height: 100%;
                object-fit: cover;
              }
            }
            .user {
              width: 100%;
              height: 100%;
              box-sizing: border-box;
              overflow: hidden;
              padding: 10px 90px 10px 60px;
              p {
                text-align: left;
                @extend %ellipsis;
                margin: 0;
                padding: 0;
                font-size: 12px;
                line-height: 20px;
              }
              .name {
                color: #4c4c4c;
              }
              .phone {
                color: #808080;
              }
            }
            .date {
              position: absolute;
              right: 5px;
              top: 21px;
              font-size: 13px;
              color: #666666;
            }
            &:nth-last-child(1) {
              border: none;
            }
          }
          .no-data {
            width: 100%;
            height: 40px;
            line-height: 40px;
            font-size: 12px;
            color: #999999;
            text-align: center;
          }
        }
      }
    }

    .back-top {
      font-size: 45px;
      color: #d08d03;
    }
  }
}
</style>
